import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface StatsCardProps {
  title: string;
  value: string;
  change?: number;
  changeLabel?: string;
  icon?: ReactNode;
  className?: string;
}
export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  change,
  changeLabel,
  icon,
  className = ''
}) => {
  return <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4 ${className}`} data-id="element-14557">
      <div className="flex items-center justify-between" data-id="element-14558">
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-14559">
          {title}
        </h3>
        {icon && <div className="flex-shrink-0" data-id="element-14560">{icon}</div>}
      </div>
      <div className="mt-2 flex items-baseline" data-id="element-14561">
        <span className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-14562">
          {value}
        </span>
      </div>
      {change !== undefined && <div className="mt-1 flex items-center text-xs" data-id="element-14563">
          {change >= 0 ? <ArrowUpRight size={14} className="text-green-500 mr-1" data-id="element-14564" /> : <ArrowDownRight size={14} className="text-red-500 mr-1" data-id="element-14565" />}
          <span className={change >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'} data-id="element-14566">
            {change >= 0 ? '+' : ''}
            {change}%
          </span>
          {changeLabel && <span className="ml-1 text-gray-500 dark:text-gray-400" data-id="element-14567">
              {changeLabel}
            </span>}
        </div>}
    </div>;
};